// extracted by mini-css-extract-plugin
export default {"short":"miniBio-module--short--18RJI","name":"miniBio-module--name--2K4Io","occupation":"miniBio-module--occupation--35ncg","bio":"miniBio-module--bio--1VEiu"};